<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <customer-form></customer-form>
  </div>
</template>
<script>
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import { mapActions, mapGetters } from 'vuex'
  import Form from './components/Form'

  export default {
    name: 'EditCustomer',
    components: { Breadcrumb, CustomerForm: Form },
    data () {
      return {
        onlyNumber: /[\D]/g,
        changeAddress: false,
        edit: true,
        isBusiness: false,
        updateByContract: false,
        lockBusiness: false,
        cepFound: false,
        id: null,
        name: '',
        email: '',
        kind: 'P',
        cpf: '',
        cnpj: '',
        companyName: '',
        tradeName: '',
        contactId: null,
        fullPhone: '',
        addressId: null,
        postalCode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        phoneMask: '',
        parsedCust: {},
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('customers.new.edit_customer'),
          'paths': {
            0: {
              'title': this.$t('customers.main.subscribers'),
              'path': '/customers'
            },
            1: {
              'title': this.$t('customers.main.edit'),
              'path': ''
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['loadCustomer']),
      defineCustomer () {
        this.id = this.customer.id
        this.name = this.customer.name
        this.email = this.customer.email
        if (this.customer.cpf) this.cpf = this.formatCPF(this.customer.cpf)
        this.kind = this.customer.kind
        this.tradeName = this.customer.trade_name
        this.companyName = this.customer.company_name
        if (this.customer.cnpj) {
          this.cnpj = this.formatCNPJ(this.customer.cnpj)
          this.isBusiness = true
        }
        if (this.customer.contact != null) {
          this.contactId = this.customer.contact.id
          this.fullPhone = this.customer.contact.area_code + this.customer.contact.number
        }
        if (this.customer.address != null) {
          this.cepFound = true
          this.changeAddress = false
          this.addressId = this.customer.address.id
          this.postalCode = this.formatCep(this.customer.address.postal_code)
          this.street = this.customer.address.street
          this.number = this.customer.address.number
          this.complement = this.customer.address.complement
          this.neighborhood = this.customer.address.neighborhood
          this.city = this.customer.address.city
          this.state = this.customer.address.state
        }
        this.$loader.hide()
      },
      formatCep (cep) {
        let regex = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/
        return cep.replace(regex, '$1.$2-$3')
      },
      formatCPF (cpf) {
        let regex = /^([\d]{3})\.*([\d]{3})\.*([\d]{3})-*([\d]{2})/
        return cpf.replace(regex, '$1.$2.$3-$4')
      },
      formatCNPJ (cnpj) {
        let regex = /^([\d]{2})\.*([\d]{3})\.*([\d]{3})-*([\d]{4}).*([\d]{2})/
        return cnpj.replace(regex, '$1.$2.$3/$4-$5')
      }
    },
    computed: {
      ...mapGetters(['customer'])
    },
    mounted () {
      if (this.$route.params !== undefined) {
        this.updateByContract = this.$route.params.updateByContract
      }
      this.loadCustomer(this.$route.params.id).then(this.defineCustomer)
    }
  }
</script>



// WEBPACK FOOTER //
// Edit.vue?16b287e5